export default __webpack_public_path__ + "static/media/app-logo-light.3eb28b16.svg";